/**
 * 브라우저에 남은 마음건강 로컬 캐시 정리.
 *
 * 리포트를 브라우저에서 계산하고 localStorage 에 쌓던 시절의 잔재다. 이제 서버가
 * 리포트를 소유하므로 읽는 코드가 없지만, 이미 배포된 브라우저에는 데이터가 남아 있다.
 * 건강정보라서 방치하지 않고 한 번 지운다.
 *
 * ⚠️ 이 파일은 다음 릴리스에서 지운다. 그때쯤이면 대부분의 브라우저가 이미 정리된다.
 */
const LEGACY_KEYS = [
  'mental_health_reports_v2',
  'mental_health_score_index_v1',
  'mental_health_reports',
] as const;

const LEGACY_SESSION_KEYS = [
  'mental_health_reports_session_v2',
  'mental_health_reports_session',
  'mental_health_session_counts_v1',
] as const;

export const purgeLegacyMentalHealthStorage = () => {
  // 시크릿 창이나 저장소 차단 설정에서는 접근 자체가 예외를 던진다.
  try {
    LEGACY_KEYS.forEach(key => localStorage.removeItem(key));
    LEGACY_SESSION_KEYS.forEach(key => sessionStorage.removeItem(key));
  } catch {
    // 지우지 못해도 앱 기동을 막지 않는다.
  }
};
